import React from "react";
import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards({
  imgPath,
  title,
  tag,
  description,
  ghLink,
  demoLink,
  isBlog,
  links,
  note,
}) {
  return (
    <Card className="project-card-view">
      {imgPath ? (
        <div className="project-image-wrap">
          <Card.Img variant="top" src={imgPath} alt={title} />
        </div>
      ) : (
        <div className="project-image-placeholder">
          <span>{title}</span>
        </div>
      )}
      <Card.Body>
        {tag && <span className="project-tag">{tag}</span>}
        <Card.Title>{title}</Card.Title>
        <Card.Text>{description}</Card.Text>
        {note && <p className="project-note">{note}</p>}
        {links.length > 0 && (
          <div className="project-inline-links">
            {links.map((link) => (
              <a key={link.href} href={link.href} target="_blank" rel="noreferrer">
                {link.label}
              </a>
            ))}
          </div>
        )}
        <div className="project-actions">
          {ghLink && (
            <Button variant="primary" href={ghLink} target="_blank">
              <BsGithub /> &nbsp;
              {isBlog ? "Blog" : "GitHub"}
            </Button>
          )}

          {!isBlog && demoLink && (
            <Button
              variant="primary"
              href={demoLink}
              target="_blank"
              className="project-link-alt"
            >
              <CgWebsite /> &nbsp;Live
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

ProjectCards.propTypes = {
  imgPath: PropTypes.string,
  title: PropTypes.string.isRequired,
  tag: PropTypes.string,
  description: PropTypes.string.isRequired,
  ghLink: PropTypes.string,
  demoLink: PropTypes.string,
  isBlog: PropTypes.bool,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  note: PropTypes.string,
};

ProjectCards.defaultProps = {
  imgPath: "",
  tag: "",
  ghLink: "",
  demoLink: "",
  isBlog: false,
  links: [],
  note: "",
};

export default ProjectCards;
